import App from './models/App'
import * as backend from '@/api/app'

export default {

  namespaced: true,

  state: {
    app: new App(),
    permissions: [],
    dashboard: {
      environment: {
        id: '',
        software: [],
        attributes: [],
        software_vulnerabilities: [],
        attribute_vulnerabilities: [],
      },
      software_vulnerabilities: [],
      attribute_vulnerabilities: [],
      cwes: [],
      environments: [],
    },
    keys: {
      SNITCH_KEY: '',
      SNITCH_ID: '',
      SNITCH_SECRET: ''
    }
  },

  mutations: {
    ...App.mutations(),
    setDashboard: (state, dashboard) => state.dashboard = dashboard,
    setUserPermissions: (state, permissions) => state.permissions = permissions,
    setKeys: (state, payload) => state.keys = payload,
  },

  actions: {
    storeApp: ({ state, commit }, payload = {}) => new Promise((resolve, reject) => backend.storeApp({
      ...state.app,
      ...payload
    }, ({ data }) => {
      commit('setApp', data.app)
      commit('setKeys', data.keys)
      resolve(data)
    }, reject)),
    loadApp: ({ commit }, appId) => new Promise((resolve, reject) => backend.loadApp(appId, ({data}) => {
      commit('setApp', data)
      resolve()
    }, reject)),
    loadDashboard: ({ commit }, appId) => new Promise((resolve, reject) => backend.loadDashboard(appId, ({data}) => {
      commit('setDashboard', data)
      resolve(data)
    }, reject)),
    updateDomain: ({ state }, domain) => new Promise((resolve, reject) => backend.updateDomain({
      domain,
      appId: state.app.id
    }, () => {
      resolve()
    }, reject)),
    updateName: ({ state }, name) => new Promise((resolve, reject) => backend.updateName({
        name,
        appId: state.app.id
      }, resolve, reject)
    ),
    deleteApp: ({}, appId) => new Promise((resolve, reject) => backend.deleteApp({
      appId
    }, () => {
      resolve()
    }, reject)),
    loadLocalEnvs: ({ commit }, appId) => new Promise((resolve, reject) => backend.loadLocalEnvs(appId, ({data}) => {
      commit('setLocalEnvs', data)
      resolve()
    }, reject)),
    uploadLogo: ({ commit, state }, payload) => new Promise((resolve, reject) => backend.uploadLogo({
      ...payload,
      appId: state.app.id
    }, ({ data }) => {
      commit('setLogoUrl', data)
      resolve()
    }, reject)),
    setDashboardEnv: ({ commit, state }, environment) => new Promise((resolve, reject) => backend.setDashboardEnv({
        environment,
        appId: state.app.id
      }, ({ data }) => {
        commit('setDashboardEnv', data)
        resolve()
      }, reject)
    ),
    updateTeam: ({ commit, state }, team_id) => new Promise((resolve, reject) => backend.updateTeam({
        team_id,
        appId: state.app.id
      }, () => {
        commit('updateTeam', team_id)
        resolve()
      }, reject)
    ),
    loadUserPermissions: ({ commit, state }) => new Promise((resolve, reject) => backend.loadUserPermissions({
        teamId: state.app.team_id,
        appId: state.app.id
      }, ({data}) => {
        commit('setUserPermissions', data)
        resolve()
      }, reject)
    ),
    loadTeam: ({ commit, state }) => new Promise((resolve, reject) => backend.loadTeam({
        appId: state.app.id
      }, ({data}) => {
        commit('setTeam', data)
        resolve()
      }, reject)
    ),
  },

  getters: {
    app: state => state.app,
    keys: state => state.keys,
    dashboard: state => state.dashboard,
    permissions: state => state.permissions,
    team: state => state.app.team
  }
}
